import React, { FC } from 'react';
import { Text, View } from '@react-pdf/renderer';
import utils, { getBadgeAdditionalColor } from '../utils';
import pdfStyles from '../../pdfDocument/pdfStyles';
import { BadgeText } from '../text/BadgeText';
import { BadgeElementViewOptions } from '../../../../types/badge';
import { FONT, PAPER_SIZE } from '../../../../types/enums';
import {
  BADGE_NAME_MAX_LENGTH,
  DEFAULT_BADGE_BACKGROUND_COLOR,
  DEFAULT_BADGE_TEXT_COLOR
} from '../../../../common/constants';
import PDFUtils from '../../../utils/pdfUtils';
import { getFontFamily } from '../../utils';

type Props = {
  badgeElementViewOptions: BadgeElementViewOptions;
  paperSize: PAPER_SIZE;
  additionalWrapperStyles?: any;
};

export const BadgeCustomerType: FC<Props> = ({ badgeElementViewOptions, paperSize, additionalWrapperStyles = {} }) => {
  const badgeName = (badgeElementViewOptions.rxBadgeName?.trim() || badgeElementViewOptions.badgeName)
    .trim().replace(/\s\s+/g, ' ').slice(0, BADGE_NAME_MAX_LENGTH);

  const getProductNameFontSize = () => {
    return utils.getMaxPixelsOfString({
      str: badgeName,
      paperSize,
      initialFontSize: 20,
      additionalMaxWidthLength: 30,
      styles: pdfStyles.customerTypeText
    });
  };

  const badgeNameFontSize = { fontSize: getProductNameFontSize() };

  const getCustomerTypeLabel = () => {
    return badgeElementViewOptions.badgeBarLetter ? badgeElementViewOptions.badgeBarLetter[0] : badgeName[0];
  };

  const elementBackgroundColor = getBadgeAdditionalColor(
    'backgroundColor',
    PDFUtils.validatePdfColor(badgeElementViewOptions.badgeBarBackgroundColour, DEFAULT_BADGE_BACKGROUND_COLOR)
  );
  const elementTextColor = getBadgeAdditionalColor(
    'color',
    PDFUtils.validatePdfColor(badgeElementViewOptions.badgeBarFontColour, DEFAULT_BADGE_TEXT_COLOR)
  );

  const label = getCustomerTypeLabel();

  return (
    <View style={[pdfStyles.customerTypeWrapper, elementBackgroundColor, additionalWrapperStyles]}>
      <View style={[pdfStyles.customerTypeWrapperLeft, elementBackgroundColor]}>
        <BadgeText text={label} style={[pdfStyles.customerTypeTextLeft, elementTextColor, getFontFamily(label, {fallbackFont: FONT.HELVETICA})]} />
      </View>
      <Text style={[pdfStyles.customerTypeText, elementTextColor, badgeNameFontSize, getFontFamily(badgeName, {fallbackFont: FONT.HELVETICA})]}>{badgeName}</Text>
    </View>
  );
};
